exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".description-ip {\n  padding: 15px 0 0 0;\n  text-align: center;\n}\n", ""]);

